import { axiosApi } from "../axios";
import { testItems } from "../types/test";

export const testAPI = async (userId: string, items: string[]) => {
  const payload: testItems = {
    items: items.map((itemId) => ({
      id: itemId,
    })),
  };

  await axiosApi.post(`/users/${userId}/test`, payload);

  return { success: true };
};

